import findParentComponent from '../components/findParentComponent';

export default (componentInstance) => {
  const form = findParentComponent(componentInstance, 'BaseForm');
  if (form !== null) {
    return form.id;
  }
  return '';
};
